import {Divider, Drawer, Form, Typography, Radio, Select, InputNumber, Row, Col, Input, notification} from "antd";
import styled from "styled-components";
import React from "react";
import {OrderFilers} from "./order-filters";
import {getUserHints} from "../../utils/getUserHints";
import {DebounceSelectUser} from "../../components/debounce-select-user";
import {Button} from "../../components/actions/button";
import {CloseSvg, RotateClockwiseSvg, SaveSvg} from "../../components/Svg";
import {LoadingOutlined, MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import {SearchBox} from "../../components/search-box";
import {SearchProducts} from "../point-products/model/use-get-point-products";

const { TextArea } = Input;
const TYPE_START_ORDER_ITEMS = [
    {
        label: "Из другого заказа",
        key: "inOrder"
    },
    {
        label: "Из пользователя",
        key: "inUser"
    },
    /*{
        label: "С нуля",
        key: "clear"
    },*/
]

const {Title, Text} = Typography;

export function CreateDrawer(
    {
        title,
        initialValues,
        onClose,
        onSave,
        isLoadingSearchData,
        onSearchOrders,
        onClearSearchOrders,
        searchOrderData,
        searchOrdersFull,
        onSearchUserAddresses,
        searchUserAddresses,
        searchUsersAddressesFull,
        searchUser,
        pointOptions,
        deliveryTypes,
        paymentTypes,
        getIntervals,
        intervals,
        onPreCheck,
    }
) {
    const [form] = Form.useForm()

    const [ typeNewOrder, setTypeNewOrder ] = React.useState(null)
    const [ isLoadForm, setIsLoadForm ] = React.useState(false)
    const [ userId, setUserId ] = React.useState(null)
    const [ deliveryTypeId, setDeliveryTypeId ] = React.useState(null)
    const [ deliveryTypeSlug, setDeliveryTypeSlug ] = React.useState(null)
    const [ selectedAddress, setSelectedAddress ] = React.useState(null)
    const [ selectedOrder, setSelectedOrder ] = React.useState(null)
    const [ selectedAllData, setSelectedAllData ] = React.useState(null)
    const [ productOptions, setProductOptions ] = React.useState([])
    const [ selectedDeliveryDate, setSelectedDeliveryDate ] = React.useState(null)
    const [ isPromoValidId, setIsPromoValidId ] = React.useState(null)
    const [sumsData, setSumsData] = React.useState({
        deliveryPrice: 0,
        totalSum: 0,
        totalSumWithDelivery: 0,
        items: []
    })
    const filteredPaymentTypes = React.useMemo(
        () => (paymentTypes ?? []).filter(
            (type) => type?.slug !== "pri-polucenii" && type?.slug !== "soxranennoi-kartoi"
        ),
        [paymentTypes]
    )
    const toNumber = (value) =>
        value === undefined || value === null ? null : Number(value)
    const dateOptions = React.useMemo(() => {
        if (!intervals) {
            return []
        }

        const today = new Date()
        const normalizeToday = new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDate()
        )

        return Object.keys(intervals)
            .sort((a, b) => {
                const [dayA, monthA, yearA] = a.split(".").map(Number)
                const [dayB, monthB, yearB] = b.split(".").map(Number)
                const dateA = new Date(yearA, monthA - 1, dayA)
                const dateB = new Date(yearB, monthB - 1, dayB)
                return dateA - dateB
            })
            .map((date) => {
                const [day, month, year] = date.split(".").map(Number)
                const dateValue = new Date(year, month - 1, day)
                const diff = Math.round((dateValue - normalizeToday) / 86400000)
                let label = date
                if (diff === 0) {
                    label = "Сегодня"
                } else if (diff === 1) {
                    label = "Завтра"
                }
                return { value: date, label }
            })
    }, [intervals])

    const intervalOptions = React.useMemo(() => {
        if (!selectedDeliveryDate) {
            return []
        }
        return (intervals?.[selectedDeliveryDate] ?? []).map((interval) => ({
            label: interval.name,
            value: interval.string,
        }))
    }, [intervals, selectedDeliveryDate])

    React.useEffect(() => {
        setUserId(null)
        setDeliveryTypeId(null)
        setDeliveryTypeSlug(null)
        setSelectedAllData(null)
    }, [typeNewOrder])

    React.useEffect(() => {
        setSelectedAllData(null)
    }, [deliveryTypeSlug])

    React.useEffect(() => {
        if (selectedAllData) {
            const items = form.getFieldValue("items") ?? []
            if (!items.length) {
                form.setFieldsValue({ items: [{ productId: null, count: 1 }] })
            }
        } else {
            form.resetFields(["items", "deliveryDate", "deliveryInterval"])
            setSelectedDeliveryDate(null)
        }
    }, [selectedAllData, form])

    React.useEffect(() => {
        if (
            selectedDeliveryDate &&
            !dateOptions.find((option) => option.value === selectedDeliveryDate)
        ) {
            setSelectedDeliveryDate(null)
            form.setFieldsValue({ deliveryDate: null, deliveryInterval: null })
        }
    }, [dateOptions, selectedDeliveryDate, form])

    function onChangeTypeNewOrder(type) {
        setTypeNewOrder(type.target.value)
    }

    function onChangeDeliveryType(typeId) {
        const slug = deliveryTypes.find((type) => type.value === typeId)?.slug
        setDeliveryTypeId(typeId)
        setDeliveryTypeSlug(slug)
    }

    async function handleUserSelect(user) {
        await onSearchUserAddresses(user.value)
        setUserId(user.value)
    }

    function selectAddress(addressValue) {
        setSelectedAddress(addressValue)
    }

    function selectOrder(orderId) {
        setSelectedOrder(orderId)
    }

    async function handleSearchProduct(name) {
        const options = await SearchProducts(name)
        setProductOptions(options)
    }

    function handleDeliveryDateChange(value) {
        setSelectedDeliveryDate(value)
        form.setFieldsValue({
            deliveryDate: value,
            deliveryInterval: null,
        })
    }

    function handleResetSelectionAddress() {
        setUserId(null)
        setSelectedAddress(null)
        setSelectedAllData(null)
        onClearSearchOrders()
    }
    function handleResetSelectionOrder() {
        setSelectedOrder(null)
        onClearSearchOrders()
    }
    function handleResetAll() {
        setTypeNewOrder(null)
        setSelectedOrder(null)
        setUserId(null)
        setSelectedAddress(null)
        setSelectedAllData(null)
        onClearSearchOrders()
        setSelectedDeliveryDate(null)
        form.resetFields()
        setProductOptions([])
    }

    function handleCreateOrderByUser() {
        if (!searchUser || !selectedAddress) {
            return
        }
        const user = {
            id: searchUser.id,
            email: searchUser.email ?? null,
            phone: searchUser.phone ?? null,
            name: searchUser.dashboardUserInfo?.name ?? "Не заполнено",
            surname: searchUser.dashboardUserInfo?.surname ?? null
        }
        const deliveryType = {
            id: deliveryTypeId,
            slug: deliveryTypeSlug,
            name: deliveryTypes.find((type) => type.value === deliveryTypeId)?.label
        };
        if (deliveryTypeSlug === "delivery") {
            const address = searchUsersAddressesFull.find((address) => address.id === selectedAddress)
            const point = pointOptions.find((point) => point.value === address.pointId)
            setSelectedAllData({
                user,
                address,
                point,
                deliveryType
            })
            setSelectedDeliveryDate(null)
            form.setFieldsValue({ deliveryDate: null, deliveryInterval: null })
            if (point?.value) {
                getIntervals(point.value, deliveryType.slug)
            }
            return
        }

        if (deliveryTypeSlug === "pickup") {
            const point = pointOptions.find((point) => point.value === selectedAddress)
            setSelectedAllData({
                user,
                address: null,
                point,
                deliveryType
            })
            setSelectedDeliveryDate(null)
            form.setFieldsValue({ deliveryDate: null, deliveryInterval: null })
            if (point?.value) {
                getIntervals(point.value, deliveryType.slug)
            }
            return
        }
    }

    async function handleCreateOrderByOrder() {
        const order = searchOrdersFull.find((order) => order.dashboardOrder.id === selectedOrder)
        await onSearchUserAddresses(order.dashboardUser.id)

        const timeout = setTimeout(() => {
            const user = {
                id: searchUser.id,
                email: searchUser.email ?? null,
                phone: searchUser.phone ?? null,
                name: searchUser.dashboardUserInfo?.name ?? "Не заполнено",
                surname: searchUser.dashboardUserInfo?.surname ?? null
            }

            const searchType = deliveryTypes.find((type) => type.slug === order.dashboardOrder.deliveryTypeSlug)
            const deliveryType = {
                id: searchType.value,
                slug: searchType.slug,
                name: searchType.label
            };
            if (deliveryType.slug === "delivery") {
                const address = searchUsersAddressesFull.find((address) => address.id === order.dashboardOrder.dashboardUserAddresses.id)
                const point = pointOptions.find((point) => point.value === address.pointId)
                setSelectedAllData({
                    user,
                    address,
                    point,
                    deliveryType
                })
                setSelectedDeliveryDate(null)
                form.setFieldsValue({ deliveryDate: null, deliveryInterval: null })
                if (point?.value) {
                    getIntervals(point.value, deliveryType.slug)
                }
                return
            }

            if (deliveryType.slug === "pickup") {
                const point = pointOptions.find((point) => point.value === order.dashboardOrder.pointId)
                setSelectedAllData({
                    user,
                    address: null,
                    point,
                    deliveryType
                })
                setSelectedDeliveryDate(null)
                form.setFieldsValue({ deliveryDate: null, deliveryInterval: null })
                if (point?.value) {
                    getIntervals(point.value, deliveryType.slug)
                }
                return
            }
        }, 1000)
    }

    function buildManualOrderPayload(values) {
        if (!selectedAllData) {
            return null
        }

        const deliveryDateValue = values.deliveryDate ?? selectedDeliveryDate
        const selectedInterval =
            intervals?.[deliveryDateValue]?.find((interval) => interval.string === values.deliveryInterval)
        const timeOrder =
            selectedInterval?.start ?? values.deliveryInterval?.split("-")?.[0] ?? null
        const timeEndOrder =
            selectedInterval?.end ?? values.deliveryInterval?.split("-")?.[1] ?? null
        const items = (values.items ?? [])
            .map((item) => ({
                productId: toNumber(item.productId),
                count: toNumber(item.count),
            }))
            .filter((item) => item.productId !== null && item.count !== null)

        return {
            userId: toNumber(selectedAllData.user?.id),
            userAddressId: toNumber(selectedAllData.address?.id),
            pointId: toNumber(selectedAllData.point?.value),
            paymentTypeId: toNumber(values.paymentTypeId ?? filteredPaymentTypes?.[0]?.value),
            deliveryTypeId: toNumber(selectedAllData.deliveryType?.id),
            // Самовывоз с DIG-252 уходит на точку сразу, без подтверждения по телефону.
            isNeedAccept: selectedAllData.deliveryType?.slug !== "pickup" && Boolean(values.isNeedAccept),
            isLessPackaging: Boolean(values.isLessPackaging),
            isToAnotherPerson: false,
            points: 0,
            isCutlery: Boolean(values.isCutlery),
            withoutDeliveryPrice: Boolean(values.withoutDeliveryPrice),
            comment: values.comment ?? "",
            phone: selectedAllData.user?.phone ?? null,
            name: selectedAllData.user?.name ?? null,
            email: selectedAllData.user?.email ?? null,
            dateOrder: deliveryDateValue,
            timeOrder,
            timeEndOrder,
            items,
            promoCodeId: isPromoValidId ? isPromoValidId : null
        }
    }

    const deliveryDate = Form.useWatch("deliveryDate", form)
    const deliveryInterval = Form.useWatch("deliveryInterval", form)
    const items = Form.useWatch("items", form) || []
    const withoutDeliveryPrice = Form.useWatch("withoutDeliveryPrice", form)

    const itemsKey = React.useMemo(() => JSON.stringify(items), [items])


    const canShowPromo =
        Boolean(deliveryDate) &&
        Boolean(deliveryInterval) &&
        items.length > 0 &&
        items.every(i => i?.productId && i?.count)

    const canShowProducts = Boolean(deliveryDate) && Boolean(deliveryInterval)

    function buildPreCheckPayload(withPromocode = false) {
        const values = form.getFieldsValue()

        const items = (values.items ?? [])
            .map(item => ({
                productId: toNumber(item.productId),
                count: toNumber(item.count),
            }))
            .filter(i => i.productId && i.count)

        if (!items.length) return null

        const payload = {
            userId: userId ?? null,
            pointId: selectedAllData?.point?.value ?? null,
            deliveryTypeId: selectedAllData?.deliveryType?.id ?? null,
            dateOrder: values.deliveryDate,
            deliveryInterval: values.deliveryInterval,
            withoutDeliveryPrice: Boolean(values.withoutDeliveryPrice) ? 1 : 0,
            items,
        }

        if (selectedAllData.address?.id) {
            payload.userAddressId = selectedAllData.address.id
        }


        if (values.promocode && values.promocode !== "") {
            payload.promocode = withPromocode || isPromoValidId ? values.promocode : null
        } else {
            payload.promocode = null
        }


        return payload
    }

    async function onHandlePreCheck() {
        const payload = buildPreCheckPayload()
        console.log(payload)

        if (!payload || !payload.items?.length || payload.items[0]?.productId == null) {
            return
        }

        setIsLoadForm(true)

        try {
            const { result } = await onPreCheck(payload)
            setSumsByResp(result)
        } catch (error) {
            notification.error({
                message: "Ошибка просчета стоимости",
            })
        } finally {
            setIsLoadForm(false)
        }
    }

    async function onHandleCheckPromoCode() {
        const payload = buildPreCheckPayload(true)

        if (!payload.promocode || payload.promocode?.trim().length <= 4) {
            form.setFields([
                {
                    name: "promocode",
                    errors: ["Промокод должен быть не короче 4 символов"],
                },
            ])
            return
        }

        try {
            const { result } = await onPreCheck(payload)
            setSumsByResp(result)

            if (result.promocodeIsValid && result.promocodeId) {
                setIsPromoValidId(result.promocodeId)

                form.setFields([
                    {
                        name: "promocode",
                        errors: [],
                    },
                ])

                notification.success({
                    message: "Промокод применён",
                })
            } else {
                setIsPromoValidId(null)

                if (result.promocodeError) {
                    form.setFields([
                        {
                            name: "promocode",
                            errors: [result.promocodeError],
                        },
                    ])
                }
            }
        } catch (e) {
            form.setFields([
                {
                    name: "promocode",
                    errors: [e?.message ?? "Промокод не применим"],
                },
            ])
        }
    }


    function setSumsByResp(result) {
        setSumsData({
            deliveryPrice: result.deliveryPrice,
            totalSum: result.totalSum,
            totalSumWithDelivery: result.totalSumWithDelivery,
            items: result.items || []
        })
    }

    function areItemsValid(items) {
        return (
            items.length > 0 &&
            items.every(i => i?.productId && i?.count && Number(i.count) > 0)
        )
    }

    React.useEffect(() => {
        if (!areItemsValid(items)) {
            return
        }

        const t = setTimeout(() => {
            onHandlePreCheck()
        }, 300)

        return () => clearTimeout(t)
    }, [itemsKey, withoutDeliveryPrice])

    async function onSubmit(values) {
        setIsLoadForm(true)
        const payload = buildManualOrderPayload(values)
        if (payload) {
            try {
                await onSave(payload)

                form.resetFields()
                handleResetAll()
                onClose()
            } catch (error) {
                console.log(error)
            } finally {
                setIsLoadForm(false)
            }
        }
    }

    const itemsMap = React.useMemo(() => {
        const map = {}

        sumsData?.items?.forEach((item) => {
            map[item.productId] = item
        })

        return map
    }, [sumsData?.items])

    const id = "new"

    return (
        <DrawerEdit
            width={"95%"}
            title={title}
            onClose={onClose}
            open
        >
            {selectedAllData
                ?
                <>
                    <SelectedData>
                        <SelectedInfo>
                            <Text><strong>Пользователь:</strong>{` ${selectedAllData.user.name} ${selectedAllData.user.surname ?? ""}`}</Text>
                            <Text><strong>Телефон:</strong> {selectedAllData.user.phone ?? "Не заполнено"} * <strong>Email:</strong> {selectedAllData.user.email ?? "Не заполнено"}</Text>
                            <Text><strong>Тип доставки:</strong> {selectedAllData.deliveryType.name}</Text>
                            <Text><strong>Адрес/Точка:</strong> {selectedAllData.deliveryType.slug === "delivery" ? selectedAllData.address.addressForView : selectedAllData.point.label}</Text>
                        </SelectedInfo>
                        <ActionsRow>
                            <Button
                                danger
                                onClick={handleResetAll}
                                icon={<RotateClockwiseSvg />}
                            >
                                Сбросить все данные
                            </Button>
                        </ActionsRow>
                    </SelectedData>
                    <OrderWrap>
                        <Title level={3}>Заказ</Title>
                        <FormEdit
                            form={form}
                            layout={"vertical"}
                            onFinish={(values) => onSubmit(values)}
                        >
                            <Divider orientation="left">Настройки заказа</Divider>
                            {/* Самовывоз с DIG-252 не подтверждается по телефону — вопрос не задаём. */}
                            {deliveryTypeSlug !== "pickup" && (
                            <StyledFormItem
                                key={id + "_isNeedAccept"}
                                label={"Нужно подверждение?"}
                                name={"isNeedAccept"}
                                initialValue={form.isNeedAccept ? form.isNeedAccept : true}
                                rules={[
                                    {
                                        required: true,
                                        message: "Выберите вариант",
                                    },
                                ]}
                            >
                                <Radio.Group
                                    buttonStyle="solid"
                                    value={form.isNeedAccept ? form.isNeedAccept : true}
                                >
                                    <Radio.Button value={true}>Да</Radio.Button>
                                    <Radio.Button value={false}>Нет</Radio.Button>
                                </Radio.Group>
                            </StyledFormItem>
                            )}

                            <StyledFormItem
                                key={id + "_isLessPackaging"}
                                label={"Меньше упоковки"}
                                name={"isLessPackaging"}
                                initialValue={form.isLessPackaging ? form.isLessPackaging : true}
                                rules={[
                                    {
                                        required: true,
                                        message: "Выберите вариант",
                                    },
                                ]}
                            >
                                <Radio.Group
                                    buttonStyle="solid"
                                    value={form.isLessPackaging ? form.isLessPackaging : true}
                                >
                                    <Radio.Button value={true}>Да</Radio.Button>
                                    <Radio.Button value={false}>Нет</Radio.Button>
                                </Radio.Group>
                            </StyledFormItem>

                            <StyledFormItem
                                key={id + "_isCutlery"}
                                label={"Нужны приборы"}
                                name={"isCutlery"}
                                initialValue={form.isCutlery ? form.isCutlery : true}
                                rules={[
                                    {
                                        required: true,
                                        message: "Выберите вариант",
                                    },
                                ]}
                            >
                                <Radio.Group
                                    buttonStyle="solid"
                                    value={form.isCutlery ? form.isCutlery : true}
                                >
                                    <Radio.Button value={true}>Да</Radio.Button>
                                    <Radio.Button value={false}>Нет</Radio.Button>
                                </Radio.Group>
                            </StyledFormItem>

                            <StyledFormItem
                                key={id + "_withoutDeliveryPrice"}
                                label={"Не учитывать доставку"}
                                name={"withoutDeliveryPrice"}
                                initialValue={form.withoutDeliveryPrice ? form.withoutDeliveryPrice : false}
                                rules={[
                                    {
                                        required: true,
                                        message: "Выберите вариант",
                                    },
                                ]}
                            >
                                <Radio.Group
                                    buttonStyle="solid"
                                    value={form.withoutDeliveryPrice ? form.withoutDeliveryPrice : false}
                                >
                                    <Radio.Button value={true}>Да</Radio.Button>
                                    <Radio.Button value={false}>Нет</Radio.Button>
                                </Radio.Group>
                            </StyledFormItem>

                            <StyledFormItem
                                key={id + "_deliveryDate"}
                                label={"Дата доставки"}
                                name={"deliveryDate"}
                                rules={[
                                    {
                                        required: true,
                                        message: "Выберите дату",
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Выберите дату"
                                    options={dateOptions}
                                    onChange={handleDeliveryDateChange}
                                    value={form.getFieldValue("deliveryDate")}
                                />
                            </StyledFormItem>

                            <StyledFormItem
                                key={id + "_deliveryInterval"}
                                label={"Интервал доставки"}
                                name={"deliveryInterval"}
                                rules={[
                                    {
                                        required: true,
                                        message: "Выберите интервал",
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Выберите интервал"
                                    options={intervalOptions}
                                    disabled={!selectedDeliveryDate}
                                />
                            </StyledFormItem>

                            <StyledFormItem
                                key={id + "_comment"}
                                label={"Комментарий к заказу"}
                                name={"comment"}
                            >
                                <TextArea rows={4} placeholder="Дополнительно, пожелания, комментарии" />
                            </StyledFormItem>
                            {canShowProducts ? (
                                <>
                                    <Divider orientation="left">Состав заказа</Divider>
                                    <Form.List name="items">
                                        {(fields, { add, remove }) => (
                                            <>
                                                {fields.map((field, index) => {
                                                    const currentItem = items?.[field.name]
                                                    const productId = currentItem?.productId
                                                    const priceItem = productId ? itemsMap?.[productId] : null

                                                    const hasDiscount =
                                                        priceItem && priceItem.price !== priceItem.priceWithDiscount

                                                    return (
                                                        <React.Fragment key={`order_item_row_${field.key}`}>
                                                            <ItemsRow>
                                                                <StyledFormItem
                                                                    label={`Продукт ${index + 1}`}
                                                                    name={[field.name, "productId"]}
                                                                    fieldKey={[field.fieldKey, "productId"]}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: "Выберите продукт",
                                                                        },
                                                                    ]}
                                                                    style={{ flex: 2, minWidth: "220px" }}
                                                                >
                                                                    <SearchBox
                                                                        placeholder="Начните вводить продукт"
                                                                        options={productOptions}
                                                                        handleSearch={handleSearchProduct}
                                                                    />
                                                                </StyledFormItem>

                                                                <StyledFormItem
                                                                    label="Количество"
                                                                    name={[field.name, "count"]}
                                                                    fieldKey={[field.fieldKey, "count"]}
                                                                    initialValue={1}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: "Введите количество",
                                                                        },
                                                                    ]}
                                                                    style={{ flex: 1, minWidth: "140px" }}
                                                                >
                                                                    <InputNumber min={1} style={{ width: "100%" }} />
                                                                </StyledFormItem>

                                                                {fields.length > 1 && (
                                                                    <RemoveIcon
                                                                        onClick={() => remove(field.name)}
                                                                    />
                                                                )}
                                                            </ItemsRow>

                                                            {/* 👇 Цена товара */}
                                                            {priceItem && (
                                                                <PriceRow>
                                                                    {hasDiscount ? (
                                                                        <>
                                                                            <OldPrice>
                                                                                <strong>Старая цена:</strong> {priceItem.price} ₽
                                                                            </OldPrice>

                                                                            <DiscountValue>
                                                                                <strong>Скидка:</strong> -{priceItem.price - priceItem.priceWithDiscount} ₽
                                                                            </DiscountValue>

                                                                            <DiscountPrice>
                                                                                <strong>Цена со скидкой:</strong> {priceItem.priceWithDiscount} ₽
                                                                            </DiscountPrice>
                                                                        </>
                                                                    ) : (
                                                                        <RegularPrice>
                                                                            <strong>Цена:</strong> {priceItem.price} ₽
                                                                        </RegularPrice>
                                                                    )}
                                                                </PriceRow>
                                                            )}
                                                        </React.Fragment>
                                                    )
                                                })}

                                                <AddItemRow>
                                                    <Button
                                                        type="dashed"
                                                        icon={<PlusOutlined />}
                                                        onClick={() => add()}
                                                    >
                                                        Добавить товар
                                                    </Button>
                                                </AddItemRow>
                                            </>
                                        )}
                                    </Form.List>

                                    <FlexWrap>
                                        <StyledFormItem
                                            key={id + "_promocode"}
                                            label="Промокод"
                                            name="promocode"
                                            rules={[
                                                { min: 4, message: "Минимум 4 символов" }
                                            ]}
                                            style={{ flex: 1 }}
                                        >
                                            <Input
                                                placeholder="Промокод"
                                                disabled={!canShowPromo}
                                                onChange={() => {
                                                    if (isPromoValidId) {
                                                        setIsPromoValidId(null)
                                                    }
                                                }}
                                            />
                                        </StyledFormItem>

                                        <Button
                                            type="primary"
                                            htmlType="button"
                                            onClick={onHandleCheckPromoCode}
                                            style={{ marginBottom: 16, height: 32 }}
                                        >
                                            Проверить
                                        </Button>

                                        <Button
                                            htmlType="button"
                                            onClick={() => {
                                                form.setFieldValue("promocode", "")
                                                setIsPromoValidId(null)
                                                onHandlePreCheck()
                                            }}
                                            style={{ marginBottom: 16, height: 32 }}
                                        >
                                            Сбросить
                                        </Button>
                                    </FlexWrap>
                                    <Title level={5}>{`промокод ${!isPromoValidId ? "НЕ " : ""}применен`}</Title>
                                </>
                            ) :  <Title level={4}>Выберите интервал доставки</Title>
                            }
                            <FlexColumn>
                                <Title style={{margin: 0}} level={4}>Стоимость заказа: <strong>{sumsData.totalSum}₽</strong></Title>
                                <Title style={{margin: 0}} level={4}>Стоимость доставки: <strong>{sumsData.deliveryPrice}₽</strong></Title>
                                <Title style={{margin: 0}} level={4}>Общая стоимость: <strong>{sumsData.totalSumWithDelivery}₽</strong></Title>
                            </FlexColumn>


                            {filteredPaymentTypes?.length > 0 && (
                                <StyledFormItem
                                    key={id + "_paymentTypeId"}
                                    label={"Тип оплаты"}
                                    name={"paymentTypeId"}
                                    initialValue={
                                        form.getFieldValue("paymentTypeId") ??
                                        filteredPaymentTypes?.[0]?.value ??
                                        null
                                    }
                                    rules={[
                                        {
                                            required: true,
                                            message: "Выберите тип оплаты",
                                        },
                                    ]}
                                >
                                    <Radio.Group
                                        buttonStyle="solid"
                                        value={
                                            form.getFieldValue("paymentTypeId") ??
                                            filteredPaymentTypes?.[0]?.value ??
                                            null
                                        }
                                    >
                                        {filteredPaymentTypes.map((type) => (
                                            <Radio.Button key={type.value} value={type.value}>
                                                {type.label}
                                            </Radio.Button>
                                        ))}
                                    </Radio.Group>
                                </StyledFormItem>
                            )}

                            <ButtonRow>
                                <ButtonCol>
                                    <Button
                                        danger
                                        onClick={handleResetAll}
                                        icon={<RotateClockwiseSvg />}
                                        disabled={isLoadForm}
                                    >
                                        Сброс всего
                                    </Button>
                                </ButtonCol>
                                <ButtonCol>
                                    <Button
                                        onClick={onClose}
                                        icon={<CloseSvg />}
                                        disabled={isLoadForm}
                                    >
                                        Закрыть
                                    </Button>
                                </ButtonCol>
                                <ButtonCol>
                                    <Button
                                        icon={<SaveSvg />}
                                        type="primary"
                                        htmlType="submit"
                                        disabled={isLoadForm}
                                    >
                                        Создать заказ
                                    </Button>
                                </ButtonCol>
                            </ButtonRow>
                        </FormEdit>
                    </OrderWrap>

                </>


                :
                <>
                    <Title level={3}>Подгрузка данных</Title>
                    <Radio.Group
                        value={typeNewOrder}
                        onChange={onChangeTypeNewOrder}
                        buttonStyle="solid"
                    >
                        {TYPE_START_ORDER_ITEMS
                            .map((type) => (
                                <Radio.Button key={type.key} value={type.key}>{type.label}</Radio.Button>
                            ))
                        }
                    </Radio.Group>

                    {typeNewOrder && (
                        <>
                            <Divider />
                            {typeNewOrder === TYPE_START_ORDER_ITEMS[0].key  && (
                                <>
                                    <OrderFilers
                                        handleSearch={onSearchOrders}
                                        handleClearFilter={onClearSearchOrders}
                                    />
                                    <InputWrap>
                                        {(searchOrderData && searchOrderData.length > 0)
                                            ?
                                            <>
                                                <Text strong>Выбор заказа</Text>
                                                <CustomSelect
                                                    placeholder={'Выберите заказ'}
                                                    options={searchOrderData}
                                                    style={{ width: "100%" }}
                                                    onSelect={selectOrder}
                                                />
                                            </>
                                            : <Text strong>ничего не найдено или нет данных в поиске</Text>
                                        }
                                    </InputWrap>
                                    {selectedOrder && (
                                        <ActionsRow>
                                            <Button
                                                danger
                                                onClick={handleResetSelectionOrder}
                                                icon={<RotateClockwiseSvg />}
                                            >
                                                Сбросить
                                            </Button>
                                            <Button
                                                type="primary"
                                                onClick={handleCreateOrderByOrder}
                                            >
                                                Собрать заказ
                                            </Button>
                                        </ActionsRow>
                                    )}
                                </>
                            )}
                            {typeNewOrder === TYPE_START_ORDER_ITEMS[1].key  && (
                                <>
                                    <InputWrap>
                                        <Text strong>Поиск пользователя: </Text>
                                        <DebounceSelectUser
                                            showSearch
                                            placeholder="Введите номер телефона"
                                            fetchOptions={getUserHints}
                                            onSelect={handleUserSelect}
                                            style={{
                                                width: "100%",
                                            }}
                                            maxTagCount="responsive"
                                        />
                                    </InputWrap>
                                    {userId && (
                                        <>
                                            <InputWrap>
                                                <Text strong>Тип дотавки: </Text>
                                                <Radio.Group
                                                    value={deliveryTypeId}
                                                    onChange={(event) => onChangeDeliveryType(event.target.value)}
                                                    buttonStyle="solid"
                                                >
                                                    {deliveryTypes
                                                        .map((type) => (
                                                            <Radio.Button key={type.value} value={type.value}>{type.label}</Radio.Button>
                                                        ))
                                                    }
                                                </Radio.Group>
                                            </InputWrap>
                                            {(deliveryTypeSlug && deliveryTypeSlug === "delivery") && (
                                                <InputWrap>
                                                    {(searchUserAddresses && searchUserAddresses.length > 0)
                                                        ?
                                                        <>
                                                            <Text strong>Выбор адреса</Text>
                                                            <CustomSelect
                                                                placeholder={'Выберите адрес'}
                                                                options={searchUserAddresses}
                                                                style={{ width: "100%" }}
                                                                value={selectedAllData?.type === "delivery" ? selectedAllData.value : undefined}
                                                                onSelect={selectAddress}
                                                            />
                                                        </>
                                                        : <Text strong>Адресов у пользователя нет</Text>
                                                    }
                                                </InputWrap>

                                            )}
                                            {(deliveryTypeSlug && deliveryTypeSlug === "pickup") && (
                                                <InputWrap>
                                                    {(pointOptions && pointOptions.length > 0)
                                                        ?
                                                        <>
                                                            <Text strong>Выбор точки</Text>
                                                            <CustomSelect
                                                                showSearch
                                                                placeholder={'Выберите точку'}
                                                                options={pointOptions}
                                                                style={{ width: "100%" }}
                                                                filterOption={(input, option) =>
                                                                    option?.label?.toLowerCase().includes(input.toLowerCase())
                                                                }
                                                                value={selectedAllData?.type === "pickup" ? selectedAllData.value : undefined}
                                                                onSelect={selectAddress}
                                                            />
                                                        </>
                                                        : <Text strong>Ошибка получения точек</Text>
                                                    }
                                                </InputWrap>
                                            )}
                                        </>
                                    )}
                                    {selectedAddress && (
                                        <ActionsRow>
                                            <Button
                                                danger
                                                onClick={handleResetSelectionAddress}
                                                icon={<RotateClockwiseSvg />}
                                            >
                                                Сбросить
                                            </Button>
                                            <Button
                                                type="primary"
                                                onClick={handleCreateOrderByUser}
                                            >
                                                Собрать заказ
                                            </Button>
                                        </ActionsRow>
                                    )}
                                </>
                            )}
                            {/*{typeNewOrder === TYPE_START_ORDER_ITEMS[2].key  && (
                                <h1>форма получения адреса</h1>
                            )}*/}
                        </>
                    )}
                </>
            }

            {isLoadingSearchData && (
                <LoadingOutlined
                    style={{
                        marginTop: "10px",
                        color: "#6574cd",
                        fontSize: "40px"
                    }}/>
            )}
        </DrawerEdit>
    )
}

const DrawerEdit = styled(Drawer)``

const FormEdit = styled(Form)``

const StyledFormItem = styled(Form.Item)`
  margin-bottom: 16px;
`

const ItemsRow = styled.div`
  position: relative;
  display: flex;
  gap: 16px;
  align-items: flex-end;
  flex-wrap: wrap;
`

const AddItemRow = styled.div`
  margin-left: 2px;
  margin-top: 8px;
`

const RemoveIcon = styled(MinusCircleOutlined)`
  font-size: 16px;
  color: #ff4d4f;
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
`

const ButtonRow = styled(Row)`
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;

  .ant-col {
    margin-left: 0.4em;
  }
`

const ButtonCol = styled(Col)`
  padding-bottom: 5px;
`

const InputWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
  width: 100%;
`

const FlexWrap = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  align-items: flex-end;
  margin-top: 15px;
`

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin: 15px 0;
`

const ActionsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
`
const CustomSelect = styled(Select)`
  width: 100%;
  
  
  .ant-select-selector {
    height: auto !important;
  }
  .ant-select-selection-item {
    max-height: 100px;
  }
`

const SelectedInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 8px;
`

const SelectedData = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 4px;
  margin-top: 8px;
`

const OrderWrap = styled.div`
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const PriceRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-top: -10px;
    margin-bottom: 12px;
`;

const OldPrice = styled.span`
    text-decoration: line-through;
    color: #999;
    margin-right: 8px;
`;

const DiscountPrice = styled.span`
    font-weight: 600;
`;

const DiscountValue = styled.span`
    color: #f5222d;
`;

const RegularPrice = styled.span``;